import React from 'react';

import {
  Typography,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Grid,
  Section,
  IconButton,
  DeleteIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import ShareAccountsForm from 'scenes/CustomAudiences/PartnerAudiences/components/ShareAccountsForm';
import { PARTNER_AUDIENCE } from 'scenes/CustomAudiences/PartnerAudiences/components/ShareAccountsForm/constants';
import { useDeleteSharedAccountsPA } from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

const SharedAccounts = ({ partnerAudience, data }) => {
  const [deleteSharedAccountsPartnerAudience] = useDeleteSharedAccountsPA();

  const [childComponent, openChildComponent] = useChildComponent();

  const handleAdd = async () => {
    openChildComponent(ShareAccountsForm, {
      initialValues: {
        [PARTNER_AUDIENCE]: partnerAudience,
      },
    });
  };

  const handleDelete = async (_e, { id, name }) => {
    await deleteSharedAccountsPartnerAudience({ id, name, partnerAudience });
  };

  const isEmpty = !data?.length;
  return (
    <React.Fragment>
      <Section
        title={`Shared accounts ${data ? `(${data?.length})` : ''}`}
        isCollapsable={!isEmpty}
        initialOpen={false}
        action={
          <IconButton
            add
            tooltip={'Share Partner Audience'}
            onClick={handleAdd}
            data-cy-action={'add-shared-account'}
          />
        }
        subTitle={isEmpty ? 'No shared accounts' : true}
      >
        {data && data.length ? (
          <TableContainer>
            <Table width={'100%'}>
              <TableBody>
                {data.map((item) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell col={'name'}>
                        <Grid direction={'column'}>
                          <Typography>{item.name}</Typography>
                          <Typography variant={'caption'} intensity={200}>
                            #{item.id}
                          </Typography>
                        </Grid>
                      </TableCell>
                      <TableCell col={'action'} align={'right'}>
                        <IconButton
                          icon={<DeleteIcon />}
                          tooltip={'Remove account'}
                          onClick={(e) => handleDelete(e, item)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}
      </Section>
      {childComponent}
    </React.Fragment>
  );
};

export default SharedAccounts;
